import React, { useState, useEffect } from "react";
import Header from "../../components/header";
import styles from "./Recategorizacion.module.css";
import History from "../../components/history";
import { Button, Form, Table, Row, Col } from "react-bootstrap";
import { Icon, InlineIcon } from '@iconify/react';
import eyeFilled from '@iconify/icons-ant-design/eye-filled';
import editFilled from '@iconify/icons-ant-design/edit-filled';
import bxsTrash from '@iconify/icons-bx/bxs-trash';
import { useCookies } from 'react-cookie';
import axios from 'axios';
import { checkSession, isMobile } from "../../core/session";
import { displayDate } from "../../core/date";
import RecategorizacionModal from "./RecategorizacionModal";
import RecategorizacionView from "./RecategorizacionView";
import DeleteConfirmation from "./DeleteConfirmation";
import TimeFilter from "../../components/time-filter"
import {formatAmount} from "../../core/amount";
import CustomPagination from "../../components/pagination/CustomPagination";

const Recategorizacion = (props) => {

    const loadingBtn = require("../../assets/loaders/btn-loading.gif");

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [totalPages, setTotalPages] = useState(1);

    const [cookie, setCookies, removeCookie] = useCookies(['kUserSession']);
    const [purchases, setPurchases] = useState([]);
    const [loading, setLoading] = useState(false);
    const [accountsLoading, setAccountsLoading] = useState(false);
    const [showModal, setModalVisibility] = useState(false);
    const [showAsignations, setAsignationsVisibility] = useState(false);

    const [fechaDesde, setFechaDesde] = useState(undefined);
    const [fechaHasta, setFechaHasta] = useState(undefined);

    const [accounts, setAccounts] = useState([]);
    const [account, setAccount] = useState(undefined);

    const [showUserDetail, setUserDetailVisibility] = useState(false);
    const [showDelete, setDeleteVisibility] = useState(false);
    const [expense, setExpense] = useState(undefined);
    const [edit, setEdit] = useState(false);

    const [owners, setOwners] = useState([]);
    const [owner, setOwner] = useState(undefined);        

    const history = [
        {
            name: "Inicio",
            path: "/"
        },
        {
            name: "Movimientos de hacienda",
            path: "/movimientos"
        }
    ]

    const prepareHeaders = () => {
        return {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
                "api_key": "k-randa",
                "access_token": cookie.kUserSession.data.access_token
            }
        };
    }

    const callbackFiltroFechas = (fechaInicio, fechaFin) => {
        setFechaDesde(fechaInicio);
        setFechaHasta(fechaFin);
    }

    const retrieveAccountingAccounts = () => {
        setAccountsLoading(true);
        var currentFarm = cookie.kUserSession.data["farm"];
        axios.get(process.env.REACT_APP_API_URL + "accountancy/accounts?id_estancia=" + currentFarm.id, prepareHeaders())
            .then(rs => {
                console.log(rs);
                if (rs.status == 200) {
                    let { data } = rs.data;
                    setAccountsLoading(false);
                    setAccounts(data);
                }
                else {
                    setAccountsLoading(false);
                    setAccounts([]);
                    setAccount(undefined);
                }
            })
            .catch(error => {
                console.error(error);
                setAccountsLoading(false);
                setAccounts([]);
                setAccount(undefined);
            });        
    }

    const handleSearch = (e) => {
        setPage(1);
        setPageSize(5);
        retrievePurchases();
    }

    const retrievePurchases = () => {
        setLoading(true);
        var currentFarm = cookie.kUserSession.data["farm"];
        var url =  "movements/entrance/recategorization?page=" + page + "&page_size=" + pageSize + "&id_estancia=" + currentFarm.id;
        
        if(fechaDesde != undefined && fechaHasta != undefined){
            url += "&start_date=" + fechaDesde + "&end_date=" + fechaHasta;
        }
        if(owner != undefined && owner.id != 0){
            url += "&id_propietario=" + owner.id;
        }        
        axios.get(process.env.REACT_APP_API_URL + url, prepareHeaders())
        .then(rs => {
            console.log(rs);
            if(rs.status == 206){
                let { content } = rs.data;
                setLoading(false);
                setTotalPages(rs.data.totalPages);
                setPurchases(content);
            }
            else {
                setLoading(false);
                setTotalPages(1);
                setPurchases([]);
            }            
        })
        .catch(error => {
            console.error(error);
            setLoading(false);
            setTotalPages(1);
            setPurchases([]);
        });
        
    }   

    const retrieveOwners = () => {
        let company = cookie.kUserSession.data["company"];
        axios.get(process.env.REACT_APP_API_URL + "owners?company_id=" + company.id , prepareHeaders())
        .then(rs => {
            if(rs.status == 200){
                let data = rs.data;
                setOwners(data);
            }
            else {
                setOwners([]);
            }
        })
        .catch(error => {
            console.error(error);
            setOwners([]);
        });
    }        

    const isSupervisor = () => {
        if(cookie.kUserSession == undefined || cookie.kUserSession == null){
            return false;
        }
        console.log(cookie.kUserSession.data);
        return cookie.kUserSession.data.rol_id == 1;
    }

    const isAdmin = () => {
        if(cookie.kUserSession == undefined || cookie.kUserSession == null){
            return false;
        }
        console.log(cookie.kUserSession.data);
        return cookie.kUserSession.data.rol_id == 2;
    }

    const isInternalAdmin = () => {
        if(cookie.kUserSession == undefined || cookie.kUserSession == null){
            return false;
        }
        console.log(cookie.kUserSession.data);
        return cookie.kUserSession.data.rol_id == 3;
    }                

    const isClient = () => {
        if(cookie.kUserSession == undefined || cookie.kUserSession == null){
            return false;
        }
        console.log(cookie.kUserSession.data);
        return cookie.kUserSession.data.rol_id == 4;
    }        

    const openUserDetailView = (e, i) => {
        setExpense(i);
        setUserDetailVisibility(true);
    }

    const openUserEdit = (e, i) => {
        setExpense(i);
        setUserDetailVisibility(true);
        setEdit(true);
    }

    const handleDelete = (e, i) => {
        setExpense(i);
        setDeleteVisibility(true);
    }

    useEffect(() => {
        checkSession("purchases", props.history, cookie.kUserSession);
        retrievePurchases();
        retrieveOwners();
    }, []);

    useEffect(() => {
        retrievePurchases();
    }, [page, pageSize]);

    const toPage = (page) => {
        console.log("Setting page to ", page);
        setPage(page);
    }

    return (
        <>
            <DeleteConfirmation show={showDelete} handleClose={() => { setDeleteVisibility(false); }} data={expense} callback={retrievePurchases} />
            <RecategorizacionView show={showUserDetail} edit={edit} handleClose={() => { setUserDetailVisibility(false); setEdit(false); }} data={expense} callback={retrievePurchases} />
            <RecategorizacionModal show={showModal} handleClose={() => { setModalVisibility(false); }} callback={retrievePurchases} />
            <Header history={props.history} />
            <section className={styles.body}>
                <Row>
                    <Col>
                        <History items={history} current={"Recategorización"} history={props.history} />
                    </Col>
                </Row>
                <Row>
                    <Col md={2}>
                        <section className={styles.side}>                
                            <Form className={styles.searchForm}>
                                <TimeFilter callback={callbackFiltroFechas}/>
                                <Row>
                                    <Col>
                                        <Form.Group style={{marginBottom: "15px"}}>
                                            <Form.Label className={styles.label}>Propietario</Form.Label>
                                            <Form.Control as="select" value={owner != undefined ? owner.id : undefined} className="karanda-input" onChange={(e) => {setOwner({...owner, id: e.target.value});}}>
                                                <option value={0}>      TODOS      </option>
                                                {
                                                    owners.map((i) => (
                                                        <option value={i.id}>{i.nombres + " " + i.apellidos}</option>
                                                    ))
                                                }
                                            </Form.Control>
                                        </Form.Group>
                                    </Col>
                                </Row>                                   
                                <Form.Row style={{ margin: "0px" }}>
                                    <Button className="karanda-btn" style={{ height: "fit-content", marginTop: "auto" }} onClick={handleSearch}>Buscar</Button>
                                </Form.Row>
                            </Form>
                        </section>
                    </Col>
                    <Col>
                        <section className={styles.content}>
                            <h1 className={styles.title}>Recategorización</h1>
                            <section className={styles.actions}>
                                {
                                    isSupervisor() || isAdmin() ? (
                                        <Button className={`karanda-btn ${styles.btnRegister}`} onClick={(e) => { setModalVisibility(true); }}>Registrar recategorización</Button>
                                    ) : (<></>)
                                }
                                {
                                    loading ? <div style={{ marginTop: "15px", textAlign: "center" }}><img src={loadingBtn} height="50" /> </div> : (

                                        purchases.length == 0 ? (
                                            <div style={{ marginTop: "15px", textAlign: "center" }}><span>No hay resultados</span></div>
                                        ) : (
                                                isMobile() ? <span>Vista no disponible</span> : 
                                                (
                                                    <>
                                                        <Table className="karanda-table" style={{ marginTop: "15px" }}>
                                                            <thead>
                                                                <th >Fecha</th>
                                                                <th >Tipo de movimiento</th>
                                                                <th >Categoría</th>
                                                                <th >Cantidad</th>
                                                                <th >CBO</th>
                                                                <th >Peso total</th>                                                                
                                                                <th >Observaciones</th>
                                                                <th >Acciones</th>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    purchases.map((i) => (
                                                                        <tr>
                                                                            <td >{displayDate(i.fecha_creacion)}</td>
                                                                            <td >{i.tipo_movimiento == "S" ? "SALIDA" : "ENTRADA"}</td>
                                                                            <td >{i.categoria.nombre}</td>
                                                                            <td >{i.cantidad}</td>
                                                                            <td >{i.carimbo}</td>
                                                                            <td >{i.peso_total}</td>                                                                            
                                                                            <td >{i.observacion}</td>
                                                                            <td >
                                                                                <Icon className={styles.icon} onClick={(e) => { openUserDetailView(e, i); }} icon={eyeFilled} height="15px" />&nbsp;&nbsp;

                                                                                {
                                                                                    isSupervisor() ? (
                                                                                        <>
                                                                                            <Icon className={styles.icon} onClick={(e) => { handleDelete(e, i); }} icon={bxsTrash} height="15px" />&nbsp;&nbsp;
                                                                                        </>
                                                                                    ) : (<></>)
                                                                                }

                                                                            </td>
                                                                        </tr>
                                                                    ))
                                                                }
                                                            </tbody>
                                                        </Table>
                                                        <CustomPagination page={page} pageSize={pageSize} changePageSize={setPageSize} toPage={toPage} totalPages={totalPages}/>
                                                    </>
                                            )
                                        )
                                    )
                                }
                            </section>
                        </section>                    
                    </Col>
                </Row>
            </section>
        </>
    );

};

export default Recategorizacion;